import * as yup from 'yup'

export const AutobiddersFiltersSchema = yup.object({
  tmsNames: yup.array().of(yup.string()),
  shipperNames: yup.array().of(yup.string()),
})

export type TAutobiddersFiltersSchema = yup.InferType<typeof AutobiddersFiltersSchema>
